/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Spanish (International)
export default {
  'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': 'Borrar selección',
  'paginated-picker.async-select.menu-list.error-message.error-message': 'No se han podido recuperar los datos',
  'paginated-picker.async-select.menu-list.error-message.retry-message': 'Haz clic para intentarlo de nuevo',
  'paginated-picker.async-select.menu-list.loading-message.loading-message': 'Cargando…',
  'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Mostrar más',
  'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} de {totalCount}',
  'paginated-picker.async-select.select.no-options-message.no-options-message': 'No se han encontrado coincidencias',
  'paginated-picker.async-select.select.option.error-message': 'No se han podido recuperar los datos',
  'paginated-picker.async-select.select.option.retry-message': 'Haz clic para intentarlo de nuevo',
  'paginated-picker.async-select.select.search-placeholder': 'Buscar',
  'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Mostrar lista completa'
};